import { Fragment } from "react";
import { AlertTriangle } from "react-feather";
import Avatar from '@components/avatar'


const ToastError = (err) => (
    <Fragment>
      <div className='toastify-header'>
        <div className='title-wrapper'>
          <Avatar size='sm' color='danger' icon={<AlertTriangle size={12} />} />
          <h6 className='toast-title fw-bold'>An error occurred</h6>
        </div>
      </div>
      <div className='toastify-body'>
        <span>Please try again later</span>
      </div>
    </Fragment>
  )

  export default ToastError